export const PAGE_PATH_HOME = "home" as const;
export const PAGE_PATH_STUDIO = "studio" as const;
export const PAGE_PATH_BACKLOG = "backlog" as const;
export const PAGE_PATH_ADMIN = "admin" as const;

export const PAGE_PATHS = [
  PAGE_PATH_HOME,
  PAGE_PATH_STUDIO,
  PAGE_PATH_BACKLOG,
  PAGE_PATH_ADMIN,
] as const;

export type PagePathType = (typeof PAGE_PATHS)[number];

export const PagePathOptions: Record<
  PagePathType,
  { label: string; description: string }
> = {
  [PAGE_PATH_HOME]: {
    label: "Home",
    description: "Go to the Home page.",
  },
  [PAGE_PATH_STUDIO]: {
    label: "Studio",
    description: "Review, search and export your profile.",
  },
  [PAGE_PATH_BACKLOG]: {
    label: "Backlog",
    description: "Manage sources to build your profile.",
  },
  [PAGE_PATH_ADMIN]: {
    label: "Admin",
    description: "For admins only.",
  },
};
